export default __webpack_public_path__ + "static/media/about_us_hero.6a0c9480.webp";